import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { createAlert } from "../../redux/reducers/Alerts";
import queryString from "query-string";
import { ReduxState } from "src/redux";

type Props = {};

const CURRENCY_TO_USD = {
  GBP: 1.25,
  CAD: 0.74,
  AUD: 0.65,
  ZAR: 0.053,
  USD: 1,
};

export const QueryParamBanner: React.FC<Props> = ({}) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { user } = useSelector((state: ReduxState) => state.User);

  const { error, success, value, currency, event, eventId } = queryString.parse(
    location.search
  );

  React.useEffect(() => {
    if (error) {
      dispatch(
        createAlert({
          type: "error",
          message: error as string,
          timeout: 0,
        })
      );
      return;
    }

    if (success) {
      dispatch(
        createAlert({
          type: "success",
          message: success as string,
          timeout: 0,
        })
      );
    }
  }, [dispatch, error, success]);

  React.useEffect(() => {
    if (!(event === "purchase" && currency && value)) {
      return;
    }

    if (window && (window as any).lintrk) {
      (window as any).lintrk("track", { conversion_id: 10568572 });
    }
    if (window) {
      const currencyUpper = (currency as string).toUpperCase();
      const valueInUSD =
        parseFloat(value.toString()) *
        (CURRENCY_TO_USD[currencyUpper as keyof typeof CURRENCY_TO_USD] || 1);

      // Read first-touch landing page set by GTM tag on docuclipper.com
      const landingMatch = document.cookie.match(/(?:^|; )dc_landing=([^;]*)/);
      let landingPath = "";
      let landingReferrer = "";
      if (landingMatch) {
        try {
          const parsed = JSON.parse(decodeURIComponent(landingMatch[1]));
          landingPath = parsed.path || "";
          landingReferrer = parsed.referrer || "";
        } catch (e) {}
      }
      const landingUrl = landingPath
        ? `https://docuclipper.com${landingPath}`
        : window.location.href;

      if ((window as any).gtag) {
        (window as any).gtag("event", "purchase", {
          transaction_id: eventId,
          value: parseFloat(value.toString()),
          currency: currencyUpper,
          page_location: landingUrl,
          page_referrer: landingReferrer || document.referrer,
          landing_page: landingPath,
        });
      }

      if ((window as any).rdt) {
        (window as any).rdt("track", "Purchase", {
          value: valueInUSD,
          currency: "USD",
          itemCount: 1,
        });
      }
      if ((window as any).fbq) {
        (window as any).fbq(
          "track",
          "Purchase",
          { value: valueInUSD, currency: "USD" },
          { eventID: eventId }
        );
      }

      if (user?.email) {
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push({
          event: "purchase_complete",
          user_data: {
            email: user?.email,
          },
          value: value,
          currency: currencyUpper,
          transaction_id: eventId,
        });
      }
    }
  }, [currency, event, eventId, user?.email, value]);

  return null;
};
export default QueryParamBanner;
